export class HistoryHelper
{
    public static addState(key, value)
    {
        const state = window.history.state;
        state[key] = value;
        window.history.replaceState(state, "");
    }
}